export function isResponseContainsKey<S, E>(response: S | E, key: string): response is S {
  return key in (response as S);
}
